export default __webpack_public_path__ + "2cdb8c9.png";